import { create, w } from '@dojo/framework/core/vdom';
import { createNlsMiddleware } from 'lcc-state';
import { Icon } from '@holmescorp/base-widgets/icon';
const factory = create({
    nls: createNlsMiddleware('ditabook')
}).properties();
export const ScoreIcon = factory(({ middleware: { nls }, properties }) => {
    const { messages: { assess_progress_threshold_low = '60', assess_progress_threshold_high = '80' } } = nls();
    const { score, useMidScore = true } = properties();
    const lowScore = parseInt(assess_progress_threshold_low) || 60;
    const highScore = parseInt(assess_progress_threshold_high) || 80;
    if (score <= 0) {
        return w(Icon, { faname: 'circle-info' });
    }
    if (score < lowScore) {
        return w(Icon, { faname: 'triangle-exclamation' });
    }
    if (score < highScore && useMidScore) {
        return w(Icon, { faname: 'circle-exclamation' });
    }
    return w(Icon, { faname: 'circle-check' });
});
export default ScoreIcon;
